<template>
  <!-- The HTML is a committed, trusted legal source; no user/server content is rendered here. -->
  <!-- eslint-disable-next-line vue/no-v-html -->
  <article
    class="membership-agreement"
    v-html="agreement.content"
  />
</template>

<script>
import agreementSource from '@/libs/privacy'

export default {
  name: 'MembershipAgreement',
  data() {
    return {
      agreement: agreementSource.privacy,
    }
  },
}
</script>

<style lang="scss">
.membership-agreement {
  color: inherit;
  font-size: 1rem;
  line-height: 1.7;

  p {
    margin: 0 0 1rem !important;
    font-family: inherit !important;
    font-size: inherit !important;
    line-height: inherit !important;
  }

  span {
    font-family: inherit !important;
    font-size: inherit !important;
    line-height: inherit !important;
  }

  a {
    overflow-wrap: anywhere;
  }
}
</style>
